import OrderJoinRequest from "../../../api/raily/order/join/order-join.request";
import OrderJoinParams from "./order-join-params";

const create = (params: OrderJoinParams): OrderJoinRequest => {
  return {
    dryRun: params.dryRun,
    sourceOrderIds: params.sourceOrderIds,
    targetOrderUuid: params.targetOrderUuid,
  };
};

const orderJoinParamsFactory = {
  create,
};

export default orderJoinParamsFactory;
